import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const PencilIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M15.363 2.301 13.68.619a2.108 2.108 0 0 0-2.983 0L.777 10.472.01 15.128a.75.75 0 0 0 .862.862l4.656-.768 9.854-9.918a2.11 2.11 0 0 0-.02-3.003Zm-9.1 7.435a.685.685 0 0 0 .973 0l3.72-3.72.893.893-5.287 5.321v-1.292h-1.5v-1.5H3.77l5.32-5.286.893.892-3.72 3.72a.688.688 0 0 0 0 .972Zm-3.696 4.58-.884-.882.38-2.3.575-.571h1.3v1.5h1.5v1.3l-.572.575-2.3.379ZM14.41 4.332l-.002.002-.001.002-1.501 1.51-2.751-2.75 1.51-1.501.002-.002.002-.002a.733.733 0 0 1 1.038 0l1.683 1.683c.309.309.31.767.02 1.058Z"/>
    </svg>
);
PencilIcon.displayName = 'PencilIcon';
export default PencilIcon;
